import React from "react";
import { Navigate } from "react-router-dom";

// Utility function to check if the token exists
const isAuthenticated = () => {
  const token = localStorage.getItem("token"); // Get the token from localStorage
  return token !== null; // If token exists, return true
};

const ProtectedRoute = ({ children }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/" />; // Redirect to login if not authenticated
  }

  return children; // Render the protected component
};

export default ProtectedRoute;
